import React, { useMemo, FC } from 'react';
import { useSelector } from 'react-redux';

import { Routes } from 'src/explore/services/Routes';
import { IStore } from 'src/explore/types/store';
import routeToExplore from 'src/prize/services/routeToExplore';

import { Link } from './atoms/Link';

interface IFooterLink {
  label: string;
  target?: string;
  url: string;
}

interface ILinksProps {
  prizeFilePath?: string;
  privacyPolicyUrl: string | null;
}

const TENANTS_WITHOUT_GOLDBELLY_LEGAL_LINKS = [ 'southside_market_and_barbeque' ];

// Tenants whose FAQ link points somewhere other than the Goldbelly help centre home page.
const TENANT_FAQ_URLS: Record<string, string> = {
  charlie_vergos_rendezvous: 'https://hogsfly.com/faqs/',
  last_crumb: 'https://help.goldbelly.com/en_us/last-crumb-account-HkFpJDHjzl',
  southside_market_and_barbeque:
    'https://help.goldbelly.com/en_us/southside-market-barbeque-account-r1EY8O_Gx',
};

export const Links: FC<ILinksProps> = ({ prizeFilePath, privacyPolicyUrl }) => {
  const account = useSelector(( state: IStore ) => state.data.account );

  const data = useMemo(() => {
    const links: IFooterLink[] = [
      {
        label: 'About Goldbelly',
        url: routeToExplore( Routes.about()),
      },
      {
        label: 'FAQ',
        url: TENANT_FAQ_URLS[prizeFilePath ?? ''] ?? Routes.help.root(),
      },
      {
        label: 'Customer Support',
        url: Routes.help.email(),
      },
    ];

    if ( !TENANTS_WITHOUT_GOLDBELLY_LEGAL_LINKS.includes( prizeFilePath ?? '' )) {
      links.push(
        {
          label: 'Terms of Service',
          target: '_blank',
          url: routeToExplore( Routes.terms()),
        },
        {
          label: 'Privacy and Security',
          target: '_blank',
          url: routeToExplore( Routes.privacy()),
        }
      );
    }

    if ( privacyPolicyUrl ) {
      links.splice( 3, 0, {
        label: 'Privacy Policy',
        target: '_blank',
        url: privacyPolicyUrl,
      });
    }

    return links;
  }, [ prizeFilePath, privacyPolicyUrl ]);

  return (
    <ul className="footer--prize__links">
      {data.map(( link ) => (
        <Link href={link.url} key={link.url} target={link.target}>
          {link.label}
        </Link>
      ))}

      {account.data && (
        <Link dataTurbolinks="false" href={Routes.auth.logOut()}>
          Sign Out
        </Link>
      )}
    </ul>
  );
};
